import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Badge, FilterButton, Pagination, Spinner } from '@/components/ui'

import { fetchBiens, setFilters, bienFilters, ordonnedBienFilters } from '../../biens/biensSlice'
import { useContactContext } from '../ContactShow'
import BienItemAsProprietaire from '../../biens/BienItem'
import BienItemAsLocataire from './BienItemAsLocataire'

const BiensList = () => {
  const { contact } = useContactContext()
  const dispatch = useDispatch()
  const biens = useSelector((state) => state.biens.items)
  const filters = useSelector((state) => state.biens.filters)
  const pagination = useSelector((state) => state.biens.pagination)
  const isLoading = useSelector((state) => state.biens.loadingStatus.fetchList)

  useEffect(() => {
    if (contact?.id) {
      dispatch(fetchBiens({ ...filters, contact_id: contact.id }))
    }
  }, [dispatch, filters, contact?.id])

  const handlePageChange = (page) => {
    dispatch(setFilters({ page }))
  }

  const handleFiltersChange = (newFilters) => {
    const filterUpdates = {
      // Réinitialiser la pagination
      page: 1
    }
  
    // Vérifier si le filtre 'type' est présent dans newFilters
    if ('type' in newFilters) {
      // Si oui, utiliser la nouvelle valeur
      filterUpdates.type = newFilters.type
    } else {
      // Si non, réinitialiser ce filtre
      filterUpdates.type = undefined
    }
    
    // Vérifier si le filtre 'nature' est présent dans newFilters
    if ('mandat' in newFilters) {
      // Si oui, utiliser la nouvelle valeur
      filterUpdates.mandat = newFilters.mandat
    } else {
      // Si non, réinitialiser ce filtre
      filterUpdates.mandat = undefined
    }
    
    // Mettre à jour les filtres dans le state Redux
    dispatch(setFilters(filterUpdates))
  }

  const getFilterBadgeText = (filterKey) => {
    const value = filters[filterKey]
    if(!value) return null;
    return bienFilters[value] ? bienFilters[value].label.toLowerCase() : null
  }
  
  return (
    <div className="mb-8">
      <div className="flex justify-between mb-4">
        <div>
          <h2 className="text-xl font-semibold mb-2">Les biens liés</h2>
          <div>
            { ['type', 'mandat'].map( (filterKey, index) => (
              getFilterBadgeText(filterKey) && 
                <Badge key={index} text={getFilterBadgeText(filterKey)} className='mr-2'/>
            ))}
          </div>
        </div>
        <div>
          <div className="dropdown">
            <FilterButton 
              filters={ordonnedBienFilters(filters)} 
              onChange={handleFiltersChange}
            />
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="table table-zebra w-full">
          <thead>
            <tr>
              <th>Codage</th>
              <th>Statut</th>
              <th>Mandat</th>
              <th>Prix</th>
              <th>Adresse</th>
              <th>Type</th>
              <th>Surface</th>
              <th>Propriétaires</th>
              <th>Locataires actuels</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            { isLoading && <tr><td colSpan="8" className="text-center"><Spinner color='gray-600'/></td></tr> }
            {(!isLoading && (!biens || biens.length === 0)) && 
                <tr>
                  <td colSpan="8" className="text-center text-gray-600 italic py-4">
                    Aucun bien lié
                  </td>
                </tr>
            } 
            {!isLoading && biens && biens.map((item, index) => {
                switch(item.as) {
                case "proprietaire":
                  return <BienItemAsProprietaire bien={item} key={index} contactContext={true} />
                case "locataire":
                  return <BienItemAsLocataire bien={item} key={index} />              
                case "acquereur":
                  return <BienItemAsProprietaire bien={item} key={index} contactContext={true} />
                }
              })
            }
          </tbody>
        </table>
        {pagination.totalPages > 1 && (
          <Pagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  )
}

export default BiensList